import React, { useEffect, useState } from "react";
import { Button, Card, Form, Input, Space, Switch } from "antd";
import UploadFile from "../../components/UploadFile";
import { AiFillCheckCircle } from "react-icons/ai";
import { useSelector, useDispatch } from "react-redux";
import { fileManagerActions } from "../../store";
import modulesApi from "../../api/module/modulesApi";
import Swal from "sweetalert2";
import UpFileSingleProp from "../../components/UpFileSingleProp";

const dataExample = {
  key: null,
  title: null,
  description: null,
  keyword: null,
  image: null,
  index: null,
};

const ProductSeo = (props) => {
  const { TextArea } = Input;
  const dispatch = useDispatch();

  const [form] = Form.useForm();
  const [valueFormData, setValueFormData] = useState(dataExample);

  const [loading, setLoading] = useState(false);

  const [image, setImage] = useState(null);

  useEffect(() => {
    getSeoSettings();
  }, [form]);

  const getSeoSettings = () => {
    setLoading(true);
    modulesApi
      .getDefaultPageSeo({
        key: "product-page",
      })
      .then((res) => {
        if (res?.values !== null) {
          const data = res?.values;
          console.log(data);
          setImage(res?.values?.image);
          form.setFieldsValue(data);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  const onUploadImage = (url) => {
    setImage(url);
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };
  const updateSettings = (item) => {
    setLoading(true);
    const data = {
      key: "product-page",
      title: item.title,
      description: item.description,
      keyword: item.keyword,
      image: image,
      index:item.index ?? false,
    };

    const payload = {
      "default-page-seo": data,
    };

    modulesApi
      .createModules(payload)
      .then((res) => {
        if (res) {
          Swal.fire({
            title: "Thành Công!",
            text: "Sửa thành công!",
            icon: "success",
            confirmButtonText: "OK",
          });
          getSeoSettings();
          setLoading(false);
        } else {
          setLoading(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  return (
    <>
      <Card
        title="Sửa các thẻ meta ở trang sản phẩm"
        className="criclebox tablespace mb-24"
        extra={
          <>
            <Space>
              <Button
                type="primary"
                icon={<AiFillCheckCircle />}
                size="large"
                onClick={() => {
                  form.submit();
                }}
              >
                &nbsp;Lưu
              </Button>
            </Space>
          </>
        }
      >
        <div>
          <br />
          <Form
            initialValues={valueFormData}
            form={form}
            labelCol={{
              span: 4,
            }}
            wrapperCol={{
              span: 14,
            }}
            onFinish={updateSettings}
            onFinishFailed={onFinishFailed}
            layout="horizontal"
            size="medium"
          >
            <Form.Item label="No-Index" name="index" valuePropName="checked">
              <Switch></Switch>
            </Form.Item>
            <Form.Item label="Thẻ image">
              <UpFileSingleProp onUploadImage={onUploadImage} image={image} />
            </Form.Item>

            <Form.Item label="Thẻ tiêu đề" name="title" tooltip="Thẻ title">
              <Input />
            </Form.Item>
            <Form.Item
              label="Mô tả meta"
              name="description"
              tooltip="Thẻ meta description"
            >
              <TextArea rows={4} />
            </Form.Item>
            <Form.Item
              label="Từ khóa meta"
              name="keyword"
              tooltip="Từ khóa meta keywords"
            >
              <Input />
            </Form.Item>
          </Form>
        </div>
      </Card>
    </>
  );
};

export default ProductSeo;
